<template>
  <div
    :aria-expanded="isExpanded"
    class="accordion-container"
    :tabindex="tabIndex"
    role="button"
    @click="onClicked"
    @keydown.enter="onClicked"
    @keydown.space="(event: Event) => onClicked(event, true)"
  >
    <div class="accordion">
      <div class="accordion__text">
        <div v-if="leftIcon" class="left-icon"><slot name="leftIcon" /></div>
        {{ heading }}
      </div>
      <div
        class="accordion__arrow-button"
        :class="{ 'accordion__arrow-button__rotated': !isExpanded }"
      >
        <IconChevroneUpMedium class="accordion__arrow-button__icon" />
      </div>
    </div>
    <div v-if="subText.length > 0" class="sub-text">{{ subText }}</div>
  </div>
</template>
<script lang="ts" setup>
import IconChevroneUpMedium from '@/design-system/assets/icons/IconChevroneUpMedium.vue'
interface EMITS {
  (e: 'onClicked')
}
const emits = defineEmits<EMITS>()
withDefaults(
  defineProps<{
    heading: string
    isExpanded: boolean
    leftIcon: boolean
    subText: string
    tabIndex: number
  }>(),
  {
    heading: '',
    isExpanded: false,
    leftIcon: false,
    subText: '',
    tabIndex: 0
  }
)

function onClicked(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('onClicked')
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.accordion-container {
  cursor: pointer;
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  .accordion {
    gap: 4px;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    display: flex;
    &__arrow-button {
      display: flex;
      cursor: pointer;
      &__icon {
        color: variables.$color-primary;
        position: relative;
        width: 24px;
        height: 24px;
      }
      &__rotated {
        transform: rotate(-180deg);
      }
    }
    &__text {
      color: variables.$color-greyscale-content;
      @include font-mixins.desktop-bold-paragraph;
      flex-direction: row;
      display: flex;
      .left-icon {
        margin-right: 8px;
        display: flex;
        align-items: center;
      }
    }
  }
  // &:focus {
  //   border: variables.$border-width-xsmall solid variables.$color-primary;
  //   outline: variables.$border-width-medium solid variables.$color-primary-light;
  //   border-radius: 4px;
  //   // Outline workaround for iPhone/Safari
  //   @supports (-webkit-overflow-scrolling: touch) {
  //     box-shadow: 0 0 0 variables.$border-width-medium variables.$color-primary-light;
  //     outline: none;
  //     -webkit-appearance: none;
  //   }
  //   // Outline workaround for iPad/Safari
  //   @media not all and (min-resolution: 0.001dpcm) {
  //     box-shadow: 0 0 0 variables.$border-width-medium variables.$color-primary-light;
  //     outline: none;
  //     -webkit-appearance: none;
  //   }
  // }
}
.sub-text {
  color: variables.$color-greyscale-secondary;
  @include font-mixins.desktop-regular-label;
  margin-left: 24px;
}
// }
:hover.accordion-container {
  background-color: variables.$color-primary;
  border-radius: 4px;
  .accordion__text {
    color: variables.$color-pure-white;
  }
  .accordion__arrow-button__icon {
    color: variables.$color-pure-white;
  }
  .sub-text {
    color: variables.$color-pure-white;
  }
}
</style>
